module.exports = __webpack_public_path__ + "img/IMG_9404.5cb5db3a.jpg";